export const certColumns =  [
  {
    title: 'Certificate Title',
    dataIndex: 'name',
  },
  {
    title: 'Organization',
    dataIndex: 'organization',
  },
  {
    title: 'Description',
    dataIndex: 'description',
  },
  {
    title: 'Duration',
    dataIndex: 'duration',
  },
  {
    title: 'Price',
    dataIndex: 'price',
  }
]

export const trainingsColumns = [
  {
    title: 'Training Name',
    dataIndex: 'name',
  },
  {
    title: 'Organizer',
    dataIndex: 'organizer',
  },
  // {
  //   title: 'Description',
  //   dataIndex: 'description',
  // },
  {
    title: 'Duration',
    dataIndex: 'duration',
  },
  {
    title: 'Format',
    dataIndex: 'type_format',
  },
  {
    title: 'Timing',
    dataIndex: 'timing',
  },
  {
    title: 'Content Type',
    dataIndex: 'content_type',
  },
  {
    title: 'Can lead to certification',
    dataIndex: 'can_lead_to_certification',
  },
  {
    title: 'Includes exams for certification',
    dataIndex: 'includes_exams_for_certification',
  },
  {
    title: 'Language',
    dataIndex: 'language',
  },
  {
    title: 'Price',
    dataIndex: 'price',
  },
  // {
  //   title: 'Link',
  //   dataIndex: 'link',
  // }
]